// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WriteoffSection_container__SEbUW {
    text-align: left;
}

.WriteoffSection_filters__vT7fD {
  margin-top: 20px;
  display: flex;
  align-items: center;
  padding: 16px;
  background-color: rgba(255, 255, 255, 1);
  border-radius: 8px;
}

.WriteoffSection_filters__select__SpgmW {
  width: 21%;
  margin-right: 1%;
}   

.WriteoffSection_date__kcZeD {
  padding: 8px;
  border-radius: 5px;
  margin-right: 1%;
  background: white;
  border: 1px solid rgba(203, 213, 225, 1);
}

.WriteoffSection_blockMoney__c46AH {
  display: flex;
  gap: 25px;
}

.WriteoffSection_blockMoneyThree__FzfQI,
.WriteoffSection_blockMoneyTwo__zIm5H,
.WriteoffSection_blockMoneyOne__MGCSO {
  width: 280px;
  background: white;
  padding: 1.25rem 1.25rem;
  border-radius: 10px;
}

.WriteoffSection_blockMoneyHead__uAKyC {
  text-align: left;
  font-size: 1.1rem;
}

.WriteoffSection_blockMoneySum__6Vrhj {
  margin-top: 10px;
  font-size: 1.75rem;
}

.WriteoffSection_blockMoneyOne__MGCSO .WriteoffSection_blockMoneySum__6Vrhj {
  color: brown;
}

.WriteoffSection_blockMoneyTwo__zIm5H .WriteoffSection_blockMoneySum__6Vrhj {
  color: blue;
}

.WriteoffSection_blockMoneyThree__FzfQI .WriteoffSection_blockMoneySum__6Vrhj {
  color: rgba(29, 135, 82, 1);
}
.WriteoffSection_tableWrapper__XJGlx {
  margin-top: 20px;
  max-height: 26vw;
  overflow-y: auto; /* важен для «липкой» шапки внутри контейнера */
  overflow-x: auto;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  position: relative; /* на всякий случай */
}

/* убери overflow:hidden у самой таблицы, иначе может клипать */
.WriteoffSection_table__Q1KTP {
  width: 100%;
  border-collapse: collapse;
  background: white;
  border-radius: 8px;
  /* overflow: hidden;  <-- убираем */
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);
}

/* фиксируем шапку внутри scroll-контейнера */
.WriteoffSection_table__Q1KTP thead th {
  position: sticky;
  top: 0; /* расстояние от верхней границы контейнера .tableWrapper */
  z-index: 5;
  background-color: #f9f9f9;
}

.WriteoffSection_page__spvf0 {
  color: red;
}
.WriteoffSection_table__Q1KTP th,
.WriteoffSection_table__Q1KTP td {
  padding: 12px 16px;
  border-bottom: 1px solid #e0e0e0;
  text-align: left;
  font-size: 14px;
}

.WriteoffSection_table__Q1KTP th {
  background-color: #f9f9f9;
  font-weight: 600;
  color: #333;
}

.WriteoffSection_table__Q1KTP tr:hover {
  background-color: #f5f5f5;
}

.WriteoffSection_add__lb1iw {
  position: absolute;
  top: 10.6rem;
  right: 2rem;
  background: rgba(29, 135, 82, 1);
  color: white;
  padding: 5px 20px;
  border-radius: 5px;
  font-size: 25px;
}`, "",{"version":3,"sources":["webpack://./src/pages/tablesStyle/WriteoffSection.module.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;;EAGE,YAAY;EACZ,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,2BAA2B;AAC7B;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB,EAAE,+CAA+C;EACjE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB,EAAE,qBAAqB;AAC3C;;AAEA,+DAA+D;AAC/D;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,mCAAmC;EACnC,sCAAsC;AACxC;;AAEA,6CAA6C;AAC7C;EACE,gBAAgB;EAChB,MAAM,EAAE,2DAA2D;EACnE,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;AACA;;EAEE,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,gCAAgC;EAChC,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB","sourcesContent":[".container {\n    text-align: left;\n}\n\n.filters {\n  margin-top: 20px;\n  display: flex;\n  align-items: center;\n  padding: 16px;\n  background-color: rgba(255, 255, 255, 1);\n  border-radius: 8px;\n}\n\n.filters__select {\n  width: 21%;\n  margin-right: 1%;\n}   \n\n.date {\n  padding: 8px;\n  border-radius: 5px;\n  margin-right: 1%;\n  background: white;\n  border: 1px solid rgba(203, 213, 225, 1);\n}\n\n.blockMoney {\n  display: flex;\n  gap: 25px;\n}\n\n.blockMoneyThree,\n.blockMoneyTwo,\n.blockMoneyOne {\n  width: 280px;\n  background: white;\n  padding: 1.25rem 1.25rem;\n  border-radius: 10px;\n}\n\n.blockMoneyHead {\n  text-align: left;\n  font-size: 1.1rem;\n}\n\n.blockMoneySum {\n  margin-top: 10px;\n  font-size: 1.75rem;\n}\n\n.blockMoneyOne .blockMoneySum {\n  color: brown;\n}\n\n.blockMoneyTwo .blockMoneySum {\n  color: blue;\n}\n\n.blockMoneyThree .blockMoneySum {\n  color: rgba(29, 135, 82, 1);\n}\n.tableWrapper {\n  margin-top: 20px;\n  max-height: 26vw;\n  overflow-y: auto; /* важен для «липкой» шапки внутри контейнера */\n  overflow-x: auto;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  position: relative; /* на всякий случай */\n}\n\n/* убери overflow:hidden у самой таблицы, иначе может клипать */\n.table {\n  width: 100%;\n  border-collapse: collapse;\n  background: white;\n  border-radius: 8px;\n  /* overflow: hidden;  <-- убираем */\n  box-shadow: 0 2px 6px rgba(0,0,0,0.05);\n}\n\n/* фиксируем шапку внутри scroll-контейнера */\n.table thead th {\n  position: sticky;\n  top: 0; /* расстояние от верхней границы контейнера .tableWrapper */\n  z-index: 5;\n  background-color: #f9f9f9;\n}\n\n.page {\n  color: red;\n}\n.table th,\n.table td {\n  padding: 12px 16px;\n  border-bottom: 1px solid #e0e0e0;\n  text-align: left;\n  font-size: 14px;\n}\n\n.table th {\n  background-color: #f9f9f9;\n  font-weight: 600;\n  color: #333;\n}\n\n.table tr:hover {\n  background-color: #f5f5f5;\n}\n\n.add {\n  position: absolute;\n  top: 10.6rem;\n  right: 2rem;\n  background: rgba(29, 135, 82, 1);\n  color: white;\n  padding: 5px 20px;\n  border-radius: 5px;\n  font-size: 25px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `WriteoffSection_container__SEbUW`,
	"filters": `WriteoffSection_filters__vT7fD`,
	"filters__select": `WriteoffSection_filters__select__SpgmW`,
	"date": `WriteoffSection_date__kcZeD`,
	"blockMoney": `WriteoffSection_blockMoney__c46AH`,
	"blockMoneyThree": `WriteoffSection_blockMoneyThree__FzfQI`,
	"blockMoneyTwo": `WriteoffSection_blockMoneyTwo__zIm5H`,
	"blockMoneyOne": `WriteoffSection_blockMoneyOne__MGCSO`,
	"blockMoneyHead": `WriteoffSection_blockMoneyHead__uAKyC`,
	"blockMoneySum": `WriteoffSection_blockMoneySum__6Vrhj`,
	"tableWrapper": `WriteoffSection_tableWrapper__XJGlx`,
	"table": `WriteoffSection_table__Q1KTP`,
	"page": `WriteoffSection_page__spvf0`,
	"add": `WriteoffSection_add__lb1iw`
};
export default ___CSS_LOADER_EXPORT___;
